import Service from './index'
import {getPrices, getGroupList, getDeviceList, deviceBuyVas} from '@/services/newMachine'
import {action, computed} from "mobx";
import {message} from "antd";


class NewMachine extends  Service{
  getPricesAPI=getPrices
  getGroupListAPI=getGroupList
  getDeviceListAPI=getDeviceList
  deviceBuyAPI=deviceBuyVas
  productId = 21

  @computed get pricesParams(): object {
    return {
      product_type: 2,
      product_id: this.productId,
      scenes: 1
    }
  }

  // 生成订单参数
  @computed get buyParams():object {
    return{
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id,
      groupId: this.groupId,
      priceId: this.priceId,
      payType: this.payType,
      priceType: 1,
      clientType: 1,
      buyIds: this.selectedIds.join(','),
      returnUrl: window.location.origin + '/home/CloudPhone'
    }
  }

  // 生成订单
  @action.bound
  async deviceBuyNewMachine(){
    if(!this.priceId &&this.priceId !== 0){
      message.error('请选择资费')
      return ;
    }
    if(!this.selectedIds.length){
      message.error('请选择购买服务的设备')
      return ;
    }
    if(!this.payType){
      message.error('请选择支付方式')
      return ;
    }

    this.deviceBuy()
  }
}

export default NewMachine
